'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxPersist = require('redux-persist');

exports.default = _reduxPersist.persistStore; // flow